import { PublicClientApplication, InteractionRequiredAuthError } from '@azure/msal-browser';

// Use the correct API scope (update with your actual API client ID)

export const msalConfig = {
  auth: {
    clientId: process.env.REACT_APP_SSO_CLIENT_ID,
    authority: process.env.REACT_APP_SSO_Authorities,
    knownAuthorities: [process.env.REACT_APP_SSO_kNOWN_Authorities],
    redirectUri: window.location.origin, // Use the current origin for redirect
    postLogoutRedirectUri: window.location.origin,
  },
  cache: {
    cacheLocation: 'localStorage',
    storeAuthStateInCookie: true,
  },
};

const loginRequest = {
  scopes: ['api://e438e517-dbd1-4e8e-a01b-df08540c0276/access_as_user'],
};

const msalInstance = new PublicClientApplication(msalConfig);

export const signInAndGetToken = async () => {
  try {
    const loginResponse = await msalInstance.loginPopup(loginRequest);
    console.log('Login successful:', loginResponse);

    // Attempt to get token silently
    const tokenResponse = await msalInstance.acquireTokenSilent({
      ...loginRequest,
      account: loginResponse.account,
    });

    console.log('Token acquired:', tokenResponse.accessToken);
    return tokenResponse.accessToken;

  } catch (error) {
    if (error instanceof InteractionRequiredAuthError) {
      // Fallback to popup if silent token fails
      const tokenResponse = await msalInstance.acquireTokenPopup(loginRequest);
      console.log('Token acquired via popup:', tokenResponse.accessToken);
      return tokenResponse.accessToken;
    } else {
      console.error('Auth error:', error);
      throw error;
    }
  }
};

export { loginRequest, msalInstance };
